export default () => {
    return {
        restrict: 'A',
        link: (scope, elem, attrs) => {
            scope[attrs.ngScopeElement] = elem;
        },
    };
};
